import React from 'react';

import { useIntl } from 'react-intl';

import IconLock from 'components/icons/lock-badge';
import { useUIContext } from 'state/ui';

import { IPlaceOrderButtonProps } from './types';
import { showPlaceOrderText } from './utils';

export const PlaceOrderText: React.FC<Omit<IPlaceOrderButtonProps, 'isLoading'>> = ({
  reloadAmount,
  confirmation,
}) => {
  const { formatMessage } = useIntl();
  const { formatCurrencyForUser } = useUIContext();

  return (
    <>
      {formatMessage(
        {
          id: showPlaceOrderText({
            reloadAndPlaceOrder: reloadAmount,
            confirmation,
          }),
        },
        {
          amount: formatCurrencyForUser(reloadAmount || 0),
          secureOrderIcon: <IconLock />,
        }
      )}
    </>
  );
};
